import React, { Component } from 'react';
import { fight_heads } from '~/tools/mll/headers';
import _ from 'lodash';
import './RecapGame.css';
import './RecapFight.css';

class RecapFight extends Component {
  state = {
    fights: [],
    selected: null
  }

  onSelect = (e) => {
    let id = e.target.id ? parseInt(e.target.id, 10) : +(e.target.value.split('')[0]) - 1;
    if (isNaN(id)) return;
    this.setState({ selected: id })
  }

  initializeProps = () => {
    const event = this.props.api.LiveEvents[0];
    const fights = _.sortBy(event.Fights, 'FightStatus').reverse();
    const index = this.state.selected !== null ? // only selects fight on initial load
    this.state.selected : _.findLastIndex(fights, (f => f.FightStatus === '1' || f.FightStatus === '2'))
    this.stats = {};
    this.setState({ fights, selected: index });
  }

  componentDidMount = () => {
    this.initializeProps()
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.api !== prevProps.api) {
      this.initializeProps()
    }
  }

  getValues = (fight, index, round, value) => {
    let stats = {
      Round: round.Round,
      Time: round.RoundTime,
      Fighter: fight[`Fighter${index % 2? 1 : 2}_LastName`],
      AS: +round.PowerArmStrikesLanded + +round.NonPowerArmStrikesLanded,
      'AS%': (this.stats.AS * 100) / +round.TotalArmStrikesThrown || 0,
      LS: +round.NonPowerLegStrikesLanded + +round.PowerLegStrikesLanded,
      'LS%': (this.stats.LS * 100) / +round.TotalLegStrikesThrown || 0,
      GS: +round.PowerGroundStrikesLanded + +round.NonPowerGroundStrikesLanded,
      'GS%': (this.stats.GS * 100) / +round.GroundStrikesThrown || 0
    };
    this.stats[value] = stats[value];
    return !isNaN(stats[value]) && value !== 'Round' ? (+stats[value]).toFixed(1) : stats[value];
  }

  displayNames = (fight) => {
    let fighters = { [fight.Fighter1_Id]: fight.Fighter1_LastName, [fight.Fighter2Id]: fight.Fighter2_LastName };
    let name1 = fighters[fight.Fighter1_Id];
    let name2 = fighters[fight.Fighter2Id];
    let label = `${name1} / ${name2}`;

    if (fight.FightStatus === '1' && fight.Rounds.length) {
      label += ' (Now)';
    } else if (fight.WinnerId) {
      let winner = fighters[fight.WinnerId];
      label =  _.replace(label, winner, winner + ' (Won)')
    }
    return label
  }

  render() {
    return (
      <div className='recap-fight'>
        <h1 className='fight-selection-title site-border-color'>Cagenomics</h1>
        <div className='recap-fight-wrapper'>
          <div className='fight-selection'>
            <h1 className='site-color'>Fights</h1>
            <div className='fights-desktop'>
              {this.state.fights.map((fight, i) => (
                <div key={i} className={`fighter ${this.state.selected === i
                  && fight.Rounds.length? 'selected site-background-color' : ''}`} style={{ opacity: !fight.Rounds.length && '.5' }}>
                  {this.state.selected === i && <span className='selected-arrow site-color'></span>}
                  <input type='radio' name='fighter' id={fight.Rounds.length? i : null} onClick={this.onSelect}/>
                  <label htmlFor={i}>
                    <span className='fight-id'>{i+1}</span>{this.displayNames(fight)}
                  </label>
                </div>
              ))}
            </div>
            <div className='fights-mobile'>
              <select onChange={this.onSelect} className='site-background-color'>
                {this.state.fights.map((fight, i) => (
                  <option key={i} value={`${i+1} ${fight.Fighter1_LastName} / ${fight.Fighter2_LastName}`} disabled={!fight.Rounds.length}>
                    {`${i+1} ${this.displayNames(fight)}`} 
                  </option>
                ))}
              </select>
            </div>
          </div>
            <table className='fights-stats' cellSpacing='0'>
              <tbody>
                <tr>  
                  {fight_heads.map((head, i) => (
                    <th key={i} className='heads'>{head}</th>
                  ))}
                </tr>
                {this.state.fights.map((fights, ii) => fights.Rounds.map((rounds, i) => (
                  ii === this.state.selected &&
                  [rounds].map((round, i) => (
                    <tr key={i}>
                      {fight_heads.map((value, ii) => (
                        <td key={ii} className='values'>
                          {this.getValues(fights, fights.Rounds.indexOf(round), round, value)}
                        </td>
                      ))}
                    </tr>
                  ))
                )))}
              </tbody>
            </table>
        </div>
        <p className='legend'><em>AS</em>: Arm Strikes, <em>LS</em>: Leg Strikes, <em>GS</em>: Ground Strikes</p>
      </div>
    )
  }
}

export default RecapFight;